import { Grid, Stack } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { ModuleHeaderText, Stepper, ModuleTitle } from '@components';
import { useStore } from '@stores';
import { globalTheme as theme } from '@styles';

import { EncryptedMessage } from '../../common/EncryptedMessage';

export const ModuleHeader = observer(() => {
  const [showEncryptedMessage, setShowEncryptedMessage] = useState(false);
  const {
    formStore: { getSubmodule },
  } = useStore();

  useEffect(() => {
    if (
      getSubmodule?.includes('SUB_CONTACT') ||
      getSubmodule?.includes('SUB_COMPACT_CONTACT')
    ) {
      setShowEncryptedMessage(true);
    } else {
      setShowEncryptedMessage(false);
    }
  }, [getSubmodule]);

  return (
    <Grid
      item
      md={4}
      xs={12}
      sx={{
        position: 'relative',
        top: 0,
        height: '100%',
        flex: 0,
        backgroundColor: 'white',
        overflow: 'hidden',
        boxSizing: 'border-box',
        maxWidth: '100%',
        [theme.breakpoints.up('md')]: {
          flex: 1,
          borderRight: 'solid 1px #e8e8e8',
        },
      }}
      data-testid="StepperGrid"
    >
      <Grid
        container
        width="100%"
        direction="column"
        sx={{
          overflow: 'hidden',
          boxSizing: 'border-box',
          maxWidth: '100%',
        }}
      >
        <Grid
          item
          sx={{
            padding: '16px 24px',
            boxSizing: 'border-box',
            width: '100%',
          }}
        >
          <Stack gap={2}>
            <ModuleTitle />
            <Stepper />
            <ModuleHeaderText />
            {showEncryptedMessage && <EncryptedMessage />}
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
});
